<div class="container-fluid">
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center flex-wrap">
      <h5 class="mb-0">Spend &amp; Analytics</h5>
      <div class="d-flex align-items-end gap-2">
        <div>
          <label class="form-label small mb-0">From</label>
          <input type="date" class="form-control form-control-sm" [(ngModel)]="fromDate" />
        </div>
        <div>
          <label class="form-label small mb-0">To</label>
          <input type="date" class="form-control form-control-sm" [(ngModel)]="toDate" />
        </div>
        <button class="btn btn-primary btn-sm" (click)="load()" [disabled]="loading">
          {{ loading ? '...' : 'Apply' }}
        </button>
      </div>
    </div>

    <div class="card-body">
      <div *ngIf="loading" class="text-center text-muted py-4">Loading...</div>

      <ng-container *ngIf="!loading && summary">
        <!-- Summary cards -->
        <div class="row g-3 mb-4">
          <div class="col-md-3 col-6">
            <div class="stat">
              <div class="stat-value text-primary">
                {{ summary.currency }} {{ summary.totals.estimatedCost | number:'1.2-2' }}
              </div>
              <div class="stat-label">Estimated spend</div>
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="stat">
              <div class="stat-value">{{ summary.totals.messages | number }}</div>
              <div class="stat-label">Billable messages</div>
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="stat">
              <div class="stat-value text-success">{{ summary.totals.delivered | number }}</div>
              <div class="stat-label">Delivered</div>
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="stat">
              <div class="stat-value text-danger">{{ summary.totals.failed | number }}</div>
              <div class="stat-label">Failed</div>
            </div>
          </div>
        </div>

        <div class="row">
          <!-- Daily cost chart -->
          <div class="col-md-7">
            <h6>Daily spend</h6>
            <div *ngIf="summary.byDay.length === 0" class="text-muted">No data in this range.</div>
            <div class="day-row" *ngFor="let d of summary.byDay">
              <div class="day-label">{{ d.date | date:'MMM d' }}</div>
              <div class="day-bar-track">
                <div class="day-bar" [style.width]="barWidth(d.cost)"></div>
              </div>
              <div class="day-cost">{{ summary.currency }} {{ d.cost | number:'1.2-2' }}</div>
            </div>
          </div>

          <!-- Per-country -->
          <div class="col-md-5">
            <h6>By country code</h6>
            <table class="table table-sm">
              <thead>
                <tr><th>Code</th><th class="text-end">Messages</th><th class="text-end">Cost</th></tr>
              </thead>
              <tbody>
                <tr *ngFor="let c of summary.byCountry">
                  <td>+{{ c.code }}</td>
                  <td class="text-end">{{ c.messages | number }}</td>
                  <td class="text-end">{{ summary.currency }} {{ c.cost | number:'1.2-2' }}</td>
                </tr>
                <tr *ngIf="summary.byCountry.length === 0"><td colspan="3" class="text-muted">No data.</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Per-campaign -->
        <h6 class="mt-3">By campaign</h6>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr><th>Campaign</th><th class="text-end">Billable messages</th><th class="text-end">Estimated cost</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of summary.byCampaign">
                <td>{{ c.name }}</td>
                <td class="text-end">{{ c.messages | number }}</td>
                <td class="text-end">{{ summary.currency }} {{ c.cost | number:'1.2-2' }}</td>
              </tr>
              <tr *ngIf="summary.byCampaign.length === 0"><td colspan="3" class="text-muted">No campaigns in this range.</td></tr>
            </tbody>
          </table>
        </div>

        <p class="text-muted small mt-2 mb-0">
          Estimates only, computed from messages we sent × a configurable rate ({{ summary.currency }}).
          Actual charges appear in Meta Business Manager. Adjust rates via WA_MARKETING_RATE / WA_SPEND_CURRENCY.
        </p>
      </ng-container>
    </div>
  </div>
</div>
